import {
   clsx
  ,Box
} from 'external/material'
import {PreviewIcon, DownloadIcon, MessageIcon, SquareArrowUpRightIcon} from 'resources/icons'
import {viewerGuard, subdomainLink} from 'utils/url'
import {inViewer} from 'settings'
import { logLessonAccess } from 'utils/lesson'

import useTranslations from 'hooks/translations'

export default function LessonLinks(props) {
  const {language} = useTranslations()
  const {hasEpl, title, scheduled, downloaded} = props

  return (<Box className="links">
    {hasEpl && <a
      className={clsx("link", "online")}
      onClick={logLessonAccess('online', props)}
      {...viewerGuard({target: "_blank", href: subdomainLink('preview', '#',  language, 'lesson', title)})}
    ><PreviewIcon fill="#2c75bd" width={25} /></a>}
    {props.onMessageClick && <span onClick={props.onMessageClick} className={clsx("link", "message")}><MessageIcon fill="#2c75bd" width={18} /></span>}
    {hasEpl && inViewer && downloaded && <a className={clsx("link", "view")} href={`//downloads/${title}`}><SquareArrowUpRightIcon fill="#2c75bd" height={20} /></a>} 
    {hasEpl && inViewer && !downloaded && <a
      className={clsx("link", "download")}
      onClick={logLessonAccess('download', {...props, id: [props.title], events: [props.id]})}
      {...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'download', `?lesson=${title}`)})}
    ><DownloadIcon fill="#2c75bd" width={17} /></a>}
    </Box>)
}
